import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'lib-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],

  animations: [
    trigger('toastTrigger', [
      state('open', style({ transform: 'translateY(0%)' })),
      state('close', style({ transform: 'translateY(-200%)' })),
      transition('open <=> close', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class ToastComponent implements OnInit {

  toastClass!: string[];
  toastTitle!: string;
  toastMessage!: string;
  device!: 'tablet' | 'mobile' | 'desktop';
  showToast!: boolean;


  constructor( public toastService: ToastService ) {
    const userAgent = window?.navigator?.userAgent;

    if (/Android/.test(userAgent) && /Chrome/.test(userAgent) && /Mobile Safari/.test(userAgent)) {
      this.device = 'mobile';
    } else if (/Android/.test(userAgent)) {
      this.device = 'mobile';
    } else {
      this.device = 'desktop';
    }
  }

  ngOnInit() {}

  dismiss(): void {
    this.toastService.dismissToast();
  }
}
